import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

const page = createSlice({
  name: 'page',
  initialState: {
    title: null,
    description: null
  },
  reducers: {
    SET_TITLE: (state, { payload = '' }) => {
      state.title = payload
    },
    SET_DESCRIPTION: (state, { payload = '' }) => {
      state.description = payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.page) {
        return {
          ...state,
          // When SSR takes procedence over the client side title
          // We use action before state to ensure the title is set correctly
          title: action.payload.page.title || state.title
        }
      }
      return state
    })
  }
})

export default page

export const pageActions = page.actions

export const pageSelectors = {
  selectPage: state => state.page,
  selectTitle: state => state.page.title,
  selectDescription: state => state.page.description
}
